import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    window.addEventListener('scroll', handleScroll);

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  const renderServicesDropdown = () => (
    <li className={`dropdown ${isMobile ? 'mobile-dropdown' : 'desktop-dropdown'}`}>
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          setDropdownOpen(!dropdownOpen);
        }}
      >
        Our Services
      </Link>
      <ul className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}>
        <li><Link to="/website-development" onClick={closeMenu}>Web Development</Link></li>
        <li><Link to="/mobile-development" onClick={closeMenu}>Mobile Development</Link></li>
        <li><Link to="/quality-assurance" onClick={closeMenu}>Quality Assurance</Link></li>
        <li><Link to="/buisness-branding" onClick={closeMenu}>Business Branding</Link></li>
        <li><Link to="/staffing-solutions" onClick={closeMenu}>Staffing Solutions</Link></li>
        <li><Link to="/graphic-designing" onClick={closeMenu}>Graphic Designing</Link></li>
        <li><Link to="/custom-web-solution" onClick={closeMenu}>Custom Web Solution</Link></li>
        <li><Link to="/social-media-marketing" onClick={closeMenu}>Social Media Marketing</Link></li>
      </ul>
    </li>
  );

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <Link to="/" onClick={closeMenu}>
          <img src="/assets/images/panorama_logo.png" alt="Logo" className="logo-image" />
        </Link>
      </div>

      {/* Hamburger Menu */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <li><Link to="/" onClick={closeMenu}>Home</Link></li>

        {/* Conditionally place Our Services based on screen size */}
        {isMobile && renderServicesDropdown()}

        <li><Link to="/about-us" onClick={closeMenu}>About Us</Link></li>
        <li><Link to="/contact-us" onClick={closeMenu}>Contact Us</Link></li>

        {/* Desktop placement */}
        {!isMobile && renderServicesDropdown()}

        <li><Link to="/career" onClick={closeMenu}>Careers</Link></li>
        <li><Link to="/blog" onClick={closeMenu}>Blogs</Link></li>
      </ul>
    </nav>
  );
};

export default Navbar;
